import { useWsFallbackRefetch } from '@/ws/fallback/useWsFallbackRefetch';
import { WsFallbackConfig } from '@/ws/fallback/types';

type WsFallbackRefetchProps = {
  config: WsFallbackConfig;
};

export const WsFallbackRefetch = ({ config }: WsFallbackRefetchProps) => {
  useWsFallbackRefetch(config);
  return null;
};
